import { useEffect, useState } from "react";

const NODES_URL = "/assets/data/productspace/umap_ps_pruned.json";
const LINKS_URL = "/assets/data/productspace/top_edges_pruned.json";

export interface ProductSpaceNodeRaw {
  product_code: string;
  x: string;
  y: string;
  total_exports?: string;
  cluster_name_short?: string;
  [key: string]: unknown;
}

export interface ProductSpaceLinkRaw {
  source: string;
  target: string;
  [key: string]: unknown;
}

export interface ProductSpaceData {
  nodes: ProductSpaceNodeRaw[];
  links: ProductSpaceLinkRaw[];
}

let cachedPromise: Promise<ProductSpaceData> | null = null;
let cached: ProductSpaceData | null = null;

export function loadProductSpaceData(): Promise<ProductSpaceData> {
  if (cachedPromise) return cachedPromise;
  cachedPromise = Promise.all([
    fetch(NODES_URL).then((r) => r.json()),
    fetch(LINKS_URL).then((r) => r.json()),
  ])
    .then(([nodes, links]) => {
      cached = { nodes, links };
      return cached;
    })
    .catch((err) => {
      cachedPromise = null;
      throw err;
    });
  return cachedPromise;
}

export function useProductSpaceStaticData(): ProductSpaceData | undefined {
  const [data, setData] = useState<ProductSpaceData | undefined>(
    () => cached ?? undefined,
  );
  useEffect(() => {
    if (data) return;
    let cancelled = false;
    loadProductSpaceData()
      .then((d) => {
        if (!cancelled) setData(d);
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, [data]);
  return data;
}
